module.exports = "https://static.wagwalking.com/_next/static/images/Avatar-3-abc604322390d61b2ea39586c635afcf.svg";